import { GlobalOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { getLocale, setLocale } from '@umijs/max';
import React from 'react';

export type SiderTheme = 'light' | 'dark';

/** 各语言在「当前语言」下的显示名（用于顶栏切换器显示为对应语言自身名称） */
const LOCALE_LABELS: Record<string, string> = {
  zh_CN: '中文',
  en_US: 'English',
  km_KH: 'ខ្មែរ',
};

const LOCALE_KEYS = ['zh_CN', 'en_US', 'km_KH'] as const;

export const SelectLang: React.FC = () => {
  const current = getLocale?.() || 'zh_CN';
  const items: MenuProps['items'] = LOCALE_KEYS.map((key) => ({
    key,
    label: LOCALE_LABELS[key],
  }));

  return (
    <Dropdown
      menu={{
        items,
        selectedKeys: [current],
        onClick: ({ key }) => setLocale?.(key),
      }}
      trigger={['click']}
      placement="bottomRight"
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 4,
          padding: '4px 8px',
          cursor: 'pointer',
          fontSize: 14,
        }}
      >
        <GlobalOutlined style={{ fontSize: 16 }} />
        <span>{LOCALE_LABELS[current] ?? current}</span>
      </span>
    </Dropdown>
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};
